import { Badge } from "@heroui/badge";
import { Button } from "@heroui/button";
import { Tooltip } from "@heroui/tooltip";
import { Bell, Loader } from "lucide-react";

import { useNotifications } from "@/features/Admin/Admin.api.ts";

interface NotificationsProps {
  showNotifications: boolean;
  setShowNotifications: (value: boolean) => void;
  notifications: number;
  setShowRequests: (value: boolean) => void;
  onOpen: () => void;
}

const Notifications = ({
  notifications,
  setShowNotifications,
  showNotifications,
  setShowRequests,
  onOpen,
}: NotificationsProps) => {
  const { error, isLoading } = useNotifications();

  // if (isLoading) {
  //   return <Spinner />;
  // }

  if (error) {
    return <div>Error fetching notifications: {error.message}</div>;
  }

  const toggle = () => {
    setShowNotifications(!showNotifications);
    setShowRequests(false);
    onOpen();
  };

  return (
    <Tooltip content={"Notifications From Activities (Farmers, Supervisors)"}>
      <Button
        isIconOnly
        aria-label="notifications"
        endContent={
          <Badge
            color="danger"
            content={isLoading ? <Loader /> : notifications}
            shape="circle"
          >
            <Bell className="fill-current" size={19} />
          </Badge>
        }
        radius="full"
        size={"lg"}
        variant="light"
        onClick={toggle}
      />
    </Tooltip>
  );
};

export default Notifications;
